<template>
    <div id="app">
        <keep-alive>
            <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"></router-view>
        <!-- <transition :name="transitionName">
            <keep-alive>
                <router-view v-if="$route.meta.keepAlive"></router-view>
            </keep-alive>
        </transition>
        <transition :name="transitionName">
            <router-view v-if="!$route.meta.keepAlive"></router-view>
        </transition>

        <van-tabbar
            class="tabbar"
            v-model="active"
            active-color="#f2ad47"
            inactive-color="#444"
            :route="true"
        >
            <van-tabbar-item to="/index">
                <span>首页</span>
                <img
                    class="index-logo"
                    slot="icon"
                    slot-scope="props"
                    :src="props.active ? nav1ImgActive : nav1Img"
                />
            </van-tabbar-item>
            <van-tabbar-item to="/course-list">
                <span>已购</span>
                <img
                    class="study-logo"
                    slot="icon"
                    slot-scope="props"
                    :src="props.active ? nav2ImgActive : nav2Img"
                />
            </van-tabbar-item>
            <van-tabbar-item @click="goQxb()">
                <span>情绪宝</span>
                <img
                    class="qxb-logo"
                    slot="icon"
                    slot-scope="props"
                    :src="props.active ? nav3ImgActive : nav3Img"
                />
            </van-tabbar-item>
            <van-tabbar-item to="/user-center">
                <span>我的</span>
                <img
                    class="my-logo"
                    slot="icon"
                    slot-scope="props"
                    :src="props.active ? nav4ImgActive : nav4Img"
                />
            </van-tabbar-item>
        </van-tabbar> -->
        <chongzhi></chongzhi>
        <youhuiquan></youhuiquan>
        <exchangeCode></exchangeCode>
        <feedback></feedback>
        <photoSwipe></photoSwipe>
    </div>
</template>

<script>
    // import Nav1Img from "./assets/nav1.png";
    // import Nav2Img from "./assets/nav2.png";
    // import Nav3Img from "./assets/nav3.png";
    // import Nav4Img from "./assets/nav4.png";
    // import Nav1ImgActive from "./assets/nav1-active.png";
    // import Nav2ImgActive from "./assets/nav2-active.png";
    // import Nav3ImgActive from "./assets/nav3-active.png";
    // import Nav4ImgActive from "./assets/nav4-active.png";
    import youhuiquan from "./components/youhuiquan/youhuiquan";
    import chongzhi from "./components/chongzhi/chongzhi";
    import exchangeCode from "./components/exchange-code/exchange-code";
    import feedback from "./components/feedback/feedback";
    import photoSwipe from "./components/photo-swipe/photo-swipe";

    // import { Dialog } from "vant";
    // import indexService from "./service/index.service";
    import rx from "./_rx";
    export default {
        name: "App",
        components: {
            youhuiquan,
            chongzhi,
            exchangeCode,
            feedback,
            photoSwipe,
        },

        created() {},

        mounted() {
            rx.emit("showYouhuiquan");
        },
    };
</script>

<style lang="scss">
    html {
        // margin: auto;
        // max-width: $maxWidth;
        height: 100%;
        font-size: 10vw;
        font-family: -apple-system, system-ui, BlinkMacSystemFont,
            Helvetica Neue, PingFang SC, Hiragino Sans GB, Microsoft YaHei,
            Arial, sans-serif;
        @include MaxWidth() {
            font-size: calc((#{$maxWidth} - 17px) / 10);
        }

        /deep/ .van-toast,
        .van-dialog {
            z-index: 4000 !important;
        }
    }

    body {
        margin: auto !important;
        max-width: $maxWidth;
        height: 100%;
        font-size: 16px;
        -webkit-text-size-adjust: none !important;
        /deep/ .van-toast__text {
            font-size: 28px;
        }
    }

    #app {
        height: 100%;
        font-family: Avenir, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        font-size: 24px;
    }

    .index-logo {
        width: 36px;
    }
    .study-logo {
        width: 48px;
    }
    .qxb-logo {
        width: 37px;
    }
    .my-logo {
        width: 36px;
    }

    .zhuanqu {
        padding: 0 22px;
        margin-bottom: 0px;
        &:last-child {
            margin-bottom: 0;
        }
        .title {
            margin-bottom: 40px;
            vertical-align: baseline;
            > span {
                margin-top: 8px;
            }
        }
        .list {
            .item {
                background: #fff;
                padding: 28px 16px 22px 16px;
                border-radius: 10px;
                display: flex;
                margin-bottom: 20px;
                &:last-child {
                    margin-bottom: 20px;
                }
                .left {
                    width: 280px;
                    margin-right: 16px;
                    position: relative;
                    .activity-time-notice-box {
                        position: absolute;
                        width: 109px;
                        top: -16px;
                        left: 8px;
                        display: none;
                        &.active {
                            display: block;
                        }
                        .notice {
                            position: absolute;
                            top: 40px;
                            left: 0;
                            width: 109px;
                            text-align: center;
                            color: #fff;
                            font-size: 24px;
                        }
                    }
                    img {
                        width: 100%;
                    }
                    .imgBox {
                        width: 100%;
                        height: 194px;
                        border-radius: 10px;
                        display: block;
                    }
                }
                .imgBox {
                    width: 100%;
                    height: 194px;
                    border-radius: 10px;
                    display: block;
                }

                .updateTime {
                    font-size: 30px;
                    color: #fff;
                    background: #fdaa25;
                    text-align: center;
                    height: 48px;
                    margin-top: 16px;
                }
            }
            .right {
                flex: 1;
                .sub-title {
                    font-size: 30px;
                    font-weight: bold;
                    color: #505050;
                    margin-bottom: 12px;
                }
                .desc {
                    font-size: 25px;
                    color: #444444;
                    margin-bottom: 18px;
                }
                .leturerBox {
                    vertical-align: baseline;
                    color: #838383;
                    margin-bottom: 14px;
                    font-size: 25px;
                    .leturer-logo {
                        width: 23px;
                        margin-right: 15px;
                        margin-left: 4px;
                    }
                    .leturers {
                        span {
                            margin-right: 20px;
                            white-space: nowrap;
                            display: inline-block;
                        }
                    }
                }
                .fenshiBox {
                    margin-bottom: 24px;
                    vertical-align: baseline;
                    .fenshi-logo {
                        width: 32px;
                        margin-right: 13px;
                    }
                    .num {
                        font-size: 30px;
                        color: #f2ad47;
                    }
                }
                .markBox {
                    .mark {
                        font-size: 18px;
                        color: #838383;
                        background: #f7f7f7;
                        padding: 6px 15px 0 15px;
                        height: 25px;
                        line-height: 25px;
                        border-radius: 25px;
                        margin-right: 20px;
                        white-space: nowrap;
                        margin-top: 6px;
                    }
                }
            }
        }
    }

    .slide-left-enter-active {
        transition: all 0.3s linear;
    }
    .slide-left-enter-leave-active {
        transition: all 0.3s linear;
    }

    .slide-left-enter,
    .slide-left-leave-to,
    .slide-left-leave-active {
        transform: translate3d(-100%, 0, 0);
    }

    .slide-right-enter-active {
        transition: all 0.3s linear;
    }
    .slide-right-enter-leave-active {
        transition: all 0.3s linear;
    }

    .slide-right-enter,
    .slide-right-leave-to,
    .slide-right-leave-active {
        transform: translate3d(100%, 0, 0);
    }

    .van-dialog {
        &.information {
            .van-dialog__message {
                padding: 0;
                white-space: normal;
                text-align: left;
                .title {
                    text-align: center;
                    height: 204px;
                    background: url("~@/assets/dialog-top2.png") no-repeat left
                        top/100%;
                    position: relative;
                    > span {
                        position: absolute;
                        color: #333;
                        font-size: 36px;
                        font-weight: bold;
                        top: 57px;
                        left: 52px;
                    }
                }
                .content {
                    font-size: 28px;
                    color: #333;
                    padding: 0 53px 24px 53px;
                    margin-top: -20px;
                    max-height: 500px;
                    overflow: auto;
                    > div {
                        margin-bottom: 10px;
                        white-space: pre-inline;
                    }
                }
            }
            .van-dialog__footer {
                display: block;
                text-align: center;
                &::after {
                    display: none;
                }
                .van-button {
                    width: 388px;
                    height: 88px;
                    border-radius: 88px;
                    background: #4688e3;
                    color: #fff;
                    font-size: 30px;
                    margin-bottom: 34px;
                }
            }
        }
    }
</style>
